import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDoneSvg } from "./IconDoneSvg.mjs";
const IconDone = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDoneSvg, ...iconProps });
};
export {
  IconDone
};
